import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M17 17H13V13H17V17ZM11 17H7V13H11V17ZM17 11H13V7H17V11ZM11 11H7V7H11V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "GridSmall"
);
